export default __webpack_public_path__ + "static/media/swf-health-app.31e0ba4f.png";